export default __webpack_public_path__ + "static/media/b1.f5cf4c82.png";